export default __webpack_public_path__ + "static/media/pagetwo.f6cfd117.txt";